import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import domtoimage from 'dom-to-image';

// import html2canvas from 'html2canvas';
@Component({
  selector: 'app-biz-card',
  templateUrl: './biz-card.component.html',
  styleUrl: './biz-card.component.scss'
})
export class BizCardComponent {
  constructor(private toastr: ToastrService){
    
  }
  bizCard: any = {}
  
  async copyLink(){
  
    try{
    
      await navigator.clipboard.writeText(`https://kachiing.com/share/${this.bizCard.id}`);
      this.toastr.success("Share link copied!")
      
  
    }catch(e){
      console.error(e)
      this.toastr.error("Couldn't copy :(")
    }
   
  }
  async shareURL() {

    const imageDiv = document.getElementById('card-image');
    if (!imageDiv) {
      console.error("Unable to find card");
      this.toastr.error("Something went wrong while sharing!");
      return;
    }
    
    const scale = 4;
    const options = {
      quality: 1,
      width: imageDiv.offsetWidth * scale,
      height: imageDiv.offsetHeight * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      },
    };
    
    this.toastr.info("Loading...")
    domtoimage
      .toJpeg(imageDiv, options)
      .then((dataUrl) => {
      
        const link = document.createElement('a');
        link.download = 'card-biz.jpeg';
        link.href = dataUrl;
        link.click();
    
       
        if (navigator.share) {
          fetch(dataUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const file = new File([blob], 'card-biz.jpeg', { type: 'image/jpeg' });
    
              navigator
                .share({
                  title: this.bizCard?.shop_description || 'Check this out!',
                  url: this.bizCard?.shop_link || '',
                  files: [file],
                })
                .then(() => console.log('Shared file'))
                .catch(console.error);
            })
            .catch(console.error);
        } else {
          console.log("Web Share API not supported");
        }
      })
      .catch((error) => {
        console.error('Error creating image:', error);
      });
    
  }

}
